import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import profileOrgStructure from '~/modules/master/redux/actions/org-structure'

const useOrgStructure = () => {
  const data = useSelector((state) => get(state, 'master.orgStructure'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(profileOrgStructure, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useOrgStructure
